<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0"><i class="ri-exchange-dollar-line me-1 text-primary"></i>
                                    Ledger Reports
                                </h5>
                            </div>
                            <div class="col">
                                <div ngbDropdown autoClose="manual" class="d-inline-block" #dropdown="ngbDropdown">
                                    <button type="button" class="btn btn-outline-secondary" id="dropdownForm1"
                                        ngbDropdownToggle>
                                        <i class="bx bx-filter"></i> Filter
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="dropdownForm1">
                                        <div class="p-3">
                                            <div class="mb-2">
                                                <label><i class="bx bx-filter mr-1"></i>Date Filter</label>
                                                <ng-select class="ng-filter" [clearable]="false" [searchable]="false"
                                                    [(ngModel)]="selectedFilter">
                                                    <ng-option *ngFor="let f of filters" [value]="f">{{ f }}</ng-option>
                                                </ng-select>
                                            </div>

                                            <ng-container *ngIf="selectedFilter === 'Custom'">
                                                <div class="mb-2">
                                                    <label><i class="bx bx-calendar mr-1"></i>From Date</label>
                                                    <input type="date" [(ngModel)]="fromDate" class="form-control">
                                                </div>
                                                <div class="mb-2">
                                                    <label><i class="bx bx-calendar mr-1"></i>To Date</label>
                                                    <input type="date" [(ngModel)]="toDate" class="form-control">
                                                </div>
                                            </ng-container>
                                            <ng-container>
                                                <div class="input-group">
                                                    <ng-select class="rcx-ng-select ng-nav" bindLabel="name"
                                                        placeholder="Select type" [(ngModel)]="type" id="filter"
                                                        [clearable]="true" [searchable]="false">
                                                        <ng-option *ngFor="let type of types"
                                                            [value]="type">{{type}}</ng-option>
                                                    </ng-select>
                                                </div>
                                            </ng-container>
                                            <button type="button"
                                                (click)="filterAndFetchLedgerReport(selectedFilter, dropdown)"
                                                class="btn btn-secondary w-100">
                                                Search
                                            </button>
                                        </div>

                                        <div class="dropdown-divider"></div>
                                    </div>
                                </div>
                                <button type="button" ngbTooltip="Download as Excel" placement="top" container="body"
                                    class="btn btn-success btn-sm ms-2" style="height: 2.3rem;"
                                    (click)="downloadExcel()">
                                    <i class="bx bx-download ri-lg align-middle me-0"></i>
                                </button>
                            </div>
                            <!-- <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary"><i class='bx bxs-layer'></i></span>
                                    <ng-select class="rcx-ng-select ng-nav" bindLabel="name" placeholder="Select type"
                                        [(ngModel)]="type" id="filter" [clearable]="true" [searchable]="false">
                                        <ng-option *ngFor="let type of types" [value]="type">{{type}}</ng-option>
                                    </ng-select>
                                </div>
                            </div> -->
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="30"></th>
                                    <th scope="col" width="200">Account Name</th>
                                    <th scope="col" width="150" class="text-center">Total Debits</th>
                                    <th scope="col" width="150" class="text-center">Total Credits</th>
                                    <th scope="col" width="150" class="text-center">Account Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let ledger of tableData.content; let i = index">
                                    <tr>
                                        <td>
                                            <i class="bx"
                                                [ngClass]="ledger.expanded ? 'bx-chevron-down' : 'bx-chevron-right'"
                                                (click)="toggleExpandRow(ledger)"></i>
                                        </td>
                                        <td>{{ ledger.accountName }}</td>
                                        <td class="text-center">{{ ledger.totalDebits === 0 ? '-' : ledger.totalDebits
                                            }}</td>
                                        <td class="text-center">{{ ledger.totalCredits === 0 ? '-' : ledger.totalCredits
                                            }}</td>
                                        <td class="text-center">{{ ledger.accountType }}</td>
                                    </tr>
                                    <tr *ngIf="ledger.expanded">
                                        <td colspan="5" class="p-0">
                                            <div class="expanded-content p-3">
                                                <div class="row">
                                                    <div class="col-md-12" style="background-color:#FFFFFF;">
                                                        <table class="table table-sm table-bordered">
                                                            <thead class="bg-light">
                                                                <tr>
                                                                    <!-- <th>Ledger ID</th> -->
                                                                    <th>Date</th>
                                                                    <th>Description</th>
                                                                    <th>Debit</th>
                                                                    <th>Credit</th>
                                                                    <th>Running Balance</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let voucher of ledger.voucherDataList">
                                                                    <!-- <td>{{ voucher.voucherId }}</td> -->
                                                                    <td>{{ voucher.date | date:'MMM dd, yyyy' }}</td>
                                                                    <td>{{ voucher.description }}</td>
                                                                    <td class="text-end">{{ voucher.debit === 0 ? '-' : voucher.debit }}
                                                                    </td>
                                                                    <td class="text-end">{{ voucher.credit === 0 ? '-' : voucher.credit
                                                                        }}</td>
                                                                    <td class="text-end">{{ voucher.runningBalance}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="5">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="tableData.content && tableData.content.length < 1; else noSearchResults">
                                            <td colspan="5">No ledger reports were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="5"
                                                *ngIf="searchKeyword && (tableData.content | search : 'accountName' : searchKeyword).length == 0">
                                                No ledger reports were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row justify-content-between align-items-center pt-3">
                            <div class="col-lg-auto">
                                <div class="pagination-entries" id="tickets-table_length">
                                    <label class="d-flex align-items-center m-0">
                                        <span>Items per page</span>
                                        <select name="tickets-table_length" aria-controls="tickets-table"
                                            [(ngModel)]="tableData.size" (change)="loadTableData(null)"
                                            class="custom-select custom-select-sm form-control form-control-sm mx-2">
                                            <option *ngFor="let page of pageSizes" [value]="page">{{page}}</option>
                                        </select>
                                    </label>
                                </div>
                            </div>
                            <div *ngIf="tableData?.content?.length > 0" class="col-lg-auto">
                                <ngb-pagination [collectionSize]="tableData.totalElements" [(page)]="tableData.number"
                                    [pageSize]="tableData.size" (pageChange)="onPageChange($event)">
                                </ngb-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>